import React from 'react'
import './Footer.scss'
import { Grid, Image } from 'semantic-ui-react'
import BraveLogo from '../../../addons/images/BRaVE-logo-white.png'
import UnionFlag from '../../../addons/images/union.jpg'
import { Link } from 'react-router'

const footerComponent = () => {
  return (
    <div className='FooterComponent'>
      <Grid style={{ width: '100%' }}>
        <Grid.Column mobile={16} tablet={8} computer={8}>
          <Link to='/'><Image src={BraveLogo} className='BraveLogo' /></Link>
          <p>© 2019 Brave, All Rights Reserved.</p>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={8} computer={8}>
          <div><Image style={{ alignSelf: 'right', marginBottom: 10 }} src={UnionFlag} className='UnionFlag' /></div>
          <p style={{ textAlign: 'right' }}>This project has received funding from the European Union's Horizon 2020
          research and <br /> innovation programme under grant agreement number 822189.</p>
          <p style={{ textAlign: 'right' }}>Terms and Conditions of Use - Data Protection</p>
        </Grid.Column>
      </Grid>
    </div>
  )
}

export default footerComponent



// WEBPACK FOOTER //
// ./src/layouts/Layout/Footer/Footer.js